<template>
    <div class="calendar-period" v-if="isDateSelected">
        {{ period }}
        <icon-close class="reset-period-icon" v-on:click.native="resetDate()" />
    </div>
</template>

<script>
import IconClose from '@img/icons/tonscan/close.svg?vue';

export default {
    computed: {
        isDateSelected() {
            return this.$store.state.datePickerFilter[0];
        },

        period() {
            const firstDate = this.formatTimestamp(this.$store.state.datePickerFilter[0]);
            const secondDate = this.formatTimestamp(this.$store.state.datePickerFilter[1] - 1);

            return `${firstDate} - ${secondDate}`;
        },
    },

    methods: {
        formatTimestamp(ts) {
            const date = new Date(ts * 1000);

            // Получаем компоненты даты
            const day = String(date.getDate()).padStart(2, '0'); // ДД
            const month = String(date.getMonth() + 1).padStart(2, '0'); // ММ (месяцы начинаются с 0)
            const year = String(date.getFullYear()).slice(-2); // ГГ (последние две цифры года)

            // Формируем строку в нужном формате
            if (this.isMobile) return `${day}.${month}`;
            return `${day}.${month}.${year}`;
        },

        resetDate() {
            this.$store.commit('resetDatePickerFilter');
        },
    },

    components: {
        IconClose,
    },
};
</script>

<style scoped lang="scss">
.calendar-period {
    display: flex;
    align-items: center;
    gap: 4px;
    box-sizing: border-box;
    padding: 4px 8px 4px 10px;
    font-weight: 500;
    color: var(--badge-blue-color);
    background-color: var(--badge-blue-background-color);
    border-radius: 20px;
    user-select: none;
    white-space: nowrap;
}
.reset-period-icon {
    cursor: pointer;
    width: 16px;
    height: 16px;
}
@media screen and (max-width: 600px) {
    .calendar-period {
        font-size: 12px;
    }
    .reset-period-icon {
        width: 14px;
        height: 14px;
    }
}
</style>
